import type { MouseEvent } from "react";
import styles from "./LawyerContactLink.module.css";

type LawyerContactLinkProps = {
  lawyerName: string | null;
  contactId: number | null;
  onLink?: () => void;
};

export const LINK_CONTACT_TITLE = "Lawyer not linked to a contact in the system — click to fix";
export const LINK_CONTACT_LABEL = "Link lawyer to a contact";
export const CHANGE_CONTACT_LABEL = "Change the linked contact";

const ICON_PROPS = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: 14,
  height: 14,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
  focusable: false,
} as const;

function BrokenLinkIcon() {
  return (
    <svg {...ICON_PROPS}>
      <path d="M9 17H7A5 5 0 0 1 7 7h2" />
      <path d="M15 7h2a5 5 0 0 1 0 10h-2" />
      <line x1="8" y1="12" x2="16" y2="12" />
      <line x1="2" y1="2" x2="22" y2="22" />
    </svg>
  );
}

function LinkIcon() {
  return (
    <svg {...ICON_PROPS}>
      <path d="M9 17H7A5 5 0 0 1 7 7h2" />
      <path d="M15 7h2a5 5 0 0 1 0 10h-2" />
      <line x1="8" y1="12" x2="16" y2="12" />
    </svg>
  );
}

export function LawyerContactLink({ lawyerName, contactId, onLink }: LawyerContactLinkProps) {
  if (!lawyerName) return <>—</>;

  const linked = contactId != null;
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onLink?.();
  };

  return (
    <>
      {lawyerName}
      {linked && ` (${contactId})`}
      <button
        type="button"
        className={`${styles.linkButton} ${linked ? styles.changeLink : styles.brokenLink}`}
        title={linked ? CHANGE_CONTACT_LABEL : LINK_CONTACT_TITLE}
        aria-label={linked ? CHANGE_CONTACT_LABEL : LINK_CONTACT_LABEL}
        onClick={handleClick}
      >
        {linked ? <LinkIcon /> : <BrokenLinkIcon />}
      </button>
    </>
  );
}
